import { storeToRefs } from 'pinia';
import { useAccountStore } from '~/stores/accountStore';
import { useMeilisearchStore } from '~/stores/meilisearchStore';

type MeilisearchConfig = {
    meilisearch?: {
        searchApiKey?: string;
        searchApiKeyUid?: string;
    };
};

const EMPTY_TENANT_TOKEN = 'TOKEN_NOT_SET';

export default defineNuxtRouteMiddleware(async () => {
    if (!import.meta.server) return; 

    const accountStore = useAccountStore();
    const meilisearchConfig = (useRuntimeConfig() as MeilisearchConfig).meilisearch || {};
    const { tenantToken } = storeToRefs(useMeilisearchStore());
    tenantToken.value = EMPTY_TENANT_TOKEN;

    if (!accountStore.state.id) return;
    
    const apiKey = meilisearchConfig.searchApiKey;
    if (!apiKey) {
        return console.warn('Meilisearch API key not configured');
    }

    try {
        const { generateTenantToken } = await import('~/utils/tenantToken.server');
        tenantToken.value = generateTenantToken(
            apiKey,
            accountStore.state.id,
            meilisearchConfig.searchApiKeyUid || '',
        );
    } catch (error) {
        console.error('Failed to generate Meilisearch tenant token:', error);
    }
}); 
